import { render } from "./BillingAccountForm.vue?vue&type=template&id=40493dd5"
import script from "./BillingAccountForm.vue?vue&type=script&lang=js"
export * from "./BillingAccountForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__